import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { CalendarRangePickerComponent, FormField } from '@at/shared';
import { startWith } from 'rxjs';

@Component({
  selector: 'at-date-selector',
  standalone: true,
  imports: [FormField, ReactiveFormsModule, DatePipe, CalendarRangePickerComponent],
  templateUrl: './date-selector.component.html',
  styleUrl: './date-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateSelectorComponent {
  readonly #formBuilder = inject(FormBuilder);

  protected readonly minStartDate = signal(new Date(new Date().toISOString().split('T')[0]));
  protected readonly dateRangeGroup = this.#formBuilder.group({
    start: this.#formBuilder.nonNullable.control(this.minStartDate(), [Validators.required]),
    end: this.#formBuilder.control<Date | null>(null),
  });
  protected readonly selectedDates = toSignal(
    this.dateRangeGroup.valueChanges.pipe(startWith(this.dateRangeGroup.value)),
  );
  protected isOneDay = computed(() => {
    const dates = this.selectedDates();

    return !dates || !dates.end || dates.start?.getTime() === dates.end.getTime();
  });

  constructor() {}

  readonly #startDateChanges = toSignal(this.dateRangeGroup.valueChanges);

  protected readonly minEndDate = computed(() => {
    const startDate = this.#startDateChanges()?.start;
    return startDate ?? this.minStartDate();
  });

  public isEditing = signal(false);

  protected done() {
    this.isEditing.set(false);
  }

  protected edit() {
    this.isEditing.set(true);
  }
}
